import React from "react";
import { Message } from "primereact/message";
import { groupIssues, isIntact } from "./integrity";

/** Сколько нарушений правила показывать сразу — остальные по кнопке. */
const VISIBLE_ISSUES = 5;

/**
 * Целостность комплекта: ошибки не дают включить комплект, предупреждения —
 * только к сведению. Нарушения сгруппированы по правилу: у реального комплекта
 * их десятки.
 */
const IntegrityReport = ({ report }) => {
  if (!report) return null;
  const errors = groupIssues(report.errors);
  const warnings = groupIssues(report.warnings);

  return (
    <div>
      {isIntact(report) ? (
        <Message severity="success" style={{ display: "block", marginBottom: 12 }}
                 text={`Комплект покрывает цепочку целиком: хабов ${report.hubs?.length ?? 0}. Его можно включить.`} />
      ) : (
        <Message severity="error" style={{ display: "block", marginBottom: 12 }}
                 text={`Нарушений целостности: ${report.errors.length}. Залить комплект можно, включить — нет, пока их не исправить в файле.`} />
      )}
      {errors.map((group) => <IssueGroup key={group.rule} group={group} tone="error" />)}
      {warnings.map((group) => <IssueGroup key={group.rule} group={group} tone="warn" />)}
    </div>
  );
};

const IssueGroup = ({ group, tone }) => {
  const [expanded, setExpanded] = React.useState(false);
  const shown = expanded ? group.items : group.items.slice(0, VISIBLE_ISSUES);
  const hidden = group.items.length - shown.length;

  return (
    <div style={{ marginBottom: 10 }}>
      <strong style={{ color: tone === "error" ? "#b91c1c" : "#b45309" }}>
        {group.label}: {group.items.length}
      </strong>
      <ul style={{ margin: "4px 0 0 0" }}>
        {shown.map((issue, i) => <li key={i}>{issue.message}</li>)}
      </ul>
      {hidden > 0 && (
        <button type="button" className="p-link" onClick={() => setExpanded(true)}>
          показать ещё {hidden}
        </button>
      )}
    </div>
  );
};

export default IntegrityReport;
